/**
 * FlickPick Sound Effects
 * Real audio files for the cinematic experience.
 */

// Preload audio files so they play instantly
const cache = {}

function load(src) {
  if (!cache[src]) {
    cache[src] = new Audio(src)
    cache[src].preload = 'auto'
  }
  return cache[src]
}

// Preload on first user interaction (browsers require interaction before audio)
let preloaded = false
export function preloadSounds() {
  if (preloaded) return
  preloaded = true
  load('/sounds/drumroll.wav')
}

/**
 * Wheel tick — short synthesized click via Web Audio API.
 * Needs to fire rapidly so we keep this synthetic (no file overhead).
 */
export function playTick(pitch = 1) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)()
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)
    osc.frequency.value = 1200 * pitch
    osc.type = 'square'
    gain.gain.setValueAtTime(0.08, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.03)
    osc.start(ctx.currentTime)
    osc.stop(ctx.currentTime + 0.03)
  } catch { /* audio not available */ }
}

/**
 * Winner ding — bright chime when the wheel lands.
 * Synthesized so it's instant with no file load delay.
 */
export function playWinnerDing() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)()
    const now = ctx.currentTime
    ;[880, 1320].forEach((freq, i) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.connect(gain)
      gain.connect(ctx.destination)
      osc.frequency.value = freq
      osc.type = 'sine'
      const start = now + i * 0.1
      gain.gain.setValueAtTime(0, start)
      gain.gain.linearRampToValueAtTime(0.15, start + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.5)
      osc.start(start)
      osc.stop(start + 0.5)
    })
  } catch { /* audio not available */ }
}

/**
 * Drum roll — tension builder before the big reveal.
 */
export function playDrumRoll() {
  const audio = load('/sounds/drumroll.wav')
  audio.currentTime = 0
  audio.volume = 0.7
  audio.play().catch(() => {})
  return audio
}

